import { Theme } from '@mui/material';

export function paper(theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          // Sombra más clara para todos los Paper
          boxShadow: '0px 2px 4px rgba(0,0,0,0.02), 0px 1px 2px rgba(0,0,0,0.015)',
          // O puedes usar diferentes elevaciones
          '&.MuiPaper-elevation1': {
            boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.02),0px 1px 1px 0px rgba(0,0,0,0.015),0px 1px 3px 0px rgba(0,0,0,0.01)',
          },
          '&.MuiPaper-elevation2': {
            boxShadow: '0 2px 10px 2px rgba(0, 0, 0, 0.04)',
          },
          '&.MuiPaper-elevation3': {
            boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.02),0px 3px 4px 0px rgba(0,0,0,0.015),0px 1px 8px 0px rgba(0,0,0,0.01)',
          },
          '&.MuiPaper-elevation4': {
            boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.02),0px 4px 5px 0px rgba(0,0,0,0.015),0px 1px 10px 0px rgba(0,0,0,0.01)',
          },
        },
      },
    },
  };
}
